import buttonStyle from "../../../assets/jss/material-dashboard-pro-react/components/buttonStyle";

const cursosStyle = {
  ...buttonStyle,
  eventLabel: {
    textAlign: "center",
    "& h2": {
      margin: 0
    },
    "& p": {
      textTransform: "uppercase",
      margin: 0,
      fontWeight: 500,
      fontSize: 21,
    },
    marginBottom: 30
  },
  PaginaFormulario: {},
  colunas: {
    display: "flex",
    flexDirection: "column",

    // Only on desktop
    "@media (min-width: 960px)": {
      flexDirection: "row",

      "& > div:last-child": {
        flex: 1,
        width: 0
      }
    },
  },
  listaSubmissoes: {
    width: 280,
    marginRight: 10
  },
  formulario: {
    flex: 1,
  },
  submissaoLista: {
    padding: "10px 15px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
    "&.visto": {
      opacity: 0.85
    },
    "&:first-child": {
      borderRadius: "6px 6px 0 0",
    },
    "&:last-child": {
      marginBottom: "10px"
    },
    "&:hover": {
      backgroundColor: "#f9f9f9",
      opacity: 1
    },
    "&:active,&.active": {
      backgroundColor: "whitesmoke",
      opacity: 1
    },
    "& .subject": {
      fontSize: "16px",
      fontWeight: "400",
      width: "calc(100% - 15px)",
      display: "inline-block",
      marginRight: 0
    },
    "& .bottom": {
      marginBottom: 0
    },
    "& .top": {
      position: "relative",
      marginBottom: 0,
      "&>svg": {
        position: "absolute",
        top: "2px",
        right: "0",
        width: "0.7em!important",
        color: "#2AAEF5"
      }
    },
    "& .date": {
      color: "gray"
    },
  },
};

export default cursosStyle;
